<div class="container map-date-picker">
  <div id="calendar-content" class="map-date-content">
    <app-range-slider-date *ngIf="timeRange"
      (maxDateEvent)="setRangeDate($event)"
      (minDateEvent)="setRangeDate($event, 'start')"
      [isRange]="true"
      [name]="'range-2'"
      [id]="'range-map'"
      [minValue]="minValueRange"
      [popoverActive]="true"
    ></app-range-slider-date>
    <app-range-slider-date *ngIf="timeMoment"
      (maxDateEvent)="setTimeMomentDate($event)"
      (minDateEvent)="setTimeMomentDate($event, 'start')"
      [isRange]="false"
      [id]="'range-map-2'"
      [popoverActive]="true"
      [minValue]="minValue"
    ></app-range-slider-date>
  </div>
</div>
